import { ticketService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    signatureStatus: 'loading',
    signature: {},
    ticket: {},
    categories: [],
    ticket_categories: [],

}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    find_loading(state) {
        state.status = 'loading'
        state.ticket = null
    },
    success(state, ticket) {
        state.status       = 'success'
        state.ticket       = ticket
    },
    successSubmitComment(state, comment) {
        state.status       = 'success'
        state.ticket.comments.push(comment)
    },
    successCategories(state, categories) {
        state.status = 'success'
        state.categories = []
        state.categories.push(...categories)
    },
    fail(state) {
        state.status       = 'fail'
    },
    successSignature(state, signature) {
        state.signatureStatus = 'success'
        state.signature = signature
    },
    setTicketCategories(state, categories) {
        state.ticket_categories = categories
    }
}

const getters = {
    status: ({status}) => status,
    categories: ({categories}) => categories,
    ticket: ({ticket}) => ticket,
    signature: ({signature}) => signature,
    signatureStatus: ({signatureStatus}) => signatureStatus,
    ticket_categories: ({ticket_categories}) => ticket_categories
}

const actions = {
    fetchCategories({commit}) {
        commit('loading')
        return ticketService.categories().then(response => {
            commit('successCategories', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('find_loading')
        return ticketService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    submitComment({commit}, data) {
        commit('loading')
        return ticketService.submitComment(data).then(response => {
            //console.log(response.data.data)
            commit('successSubmitComment', response.data.data)
        })
    },
    deleteComment({commit}, hashid) {
        commit('loading')
        return ticketService.delete(hashid)

    },
    updateComment({commit}, data) {
        commit('loading')
        return ticketService.updateComment(data)
    },
    fetchSignature({commit}) {
        return ticketService.fetchSignature().then(response => {
            commit("successSignature", response.data.data)
        })
    },

    fetchTicketCategories({commit}, query) {
        commit('loading')
        return ticketService.fetchTicketCategories(query)
            .then(response => {
                commit('setTicketCategories', response.data.data)
            })
    }
}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}